<template>
  <div>
    <storage-room-table v-show="activeKey===1" ref="list" :storage-environments="storageEnvironments" :storage-room-types="storageRoomTypes" @add="add" @edit="edit"/>
    <storage-room-detail v-show="activeKey===2" ref="detail" :container-types="containerTypes" :item-types="itemTypes" :order-types="orderTypes" :owners="owners" :pack-types="packTypes" :storage-environments="storageEnvironments" :storage-room-types="storageRoomTypes" :transmission-types="transmissionTypes" @back="back"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import StorageRoomTable from '@/views/basedata/storageroom/StorageRoomTable.vue'
import StorageRoomDetail from '@/views/basedata/storageroom/StorageRoomDetail.vue'
import { getDictionaries, getEnums, getOptions } from '@/utils/util'

export default {
  name: 'StorageRoomBaseData',
  components: { StorageRoomTable, StorageRoomDetail },
  data() {
    return {
      activeKey: 1,
      storageRoomTypes: [],
      storageEnvironments: [],
      containerTypes: [],
      packTypes: [],
      transmissionTypes: [],
      owners: [],
      orderTypes: [],
      itemTypes: []
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
      return findAll('orderTypeFactory', { available: true, operationType: 2 })
    }).then(res => {
      if (res.success) {
        this.orderTypes = getOptions(res.result)
      }
      return findAll('containerTypeFactory', { available: true })
    }).then(res => {
      if (res.success) {
        this.containerTypes = getOptions(res.result)
      }
      return getEnums('StorageRoomType')
    }).then(result => {
      this.storageRoomTypes = result
      return getEnums('StorageEnvironment')
    }).then(result => {
      this.storageEnvironments = result
      return getEnums('PackType')
    }).then(result => {
      this.packTypes = result
      return getEnums('TransmissionType')
    }).then(result => {
      this.transmissionTypes = result
      return getDictionaries('ITEM_TYPE')
    }).then(result => {
      this.itemTypes = result
    })
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.refresh()
    },
    add() {
      this.activeKey = 2
      this.$refs.detail.add()
    },
    edit(row) {
      this.activeKey = 2
      this.$refs.detail.refresh(row.id)
    }
  }
}
</script>